<template>
    <div class="installment">
        <modal-win
            :type="modalType"
            ref="modal"
        />
        <div class="title">Рассрочка платежа</div>
        <p class="page-hint installment-desc">
            Оплачивайте задолженность частями — без залога и поручителей.<br>Выберите подходящий срок и подайте заявку онлайн.
        </p>

        <div class="installment-plans flex">
            <div class="installment-plan">
                <div class="installment-plan__rate">0%</div>
                <div class="installment-plan__term">до 6 месяцев</div>
                <div class="installment-plan__note">Взнос не менее 1/6</div>
            </div>
            <div class="installment-plan">
                <div class="installment-plan__rate">12,5%</div>
                <div class="installment-plan__term">до 12 месяцев</div>
                <div class="installment-plan__note">Взнос не менее 1/12</div>
            </div>
            <div class="installment-plan">
                <div class="installment-plan__rate installment-plan__rate--text">Индивидуальный</div>
                <div class="installment-plan__note">Уточняйте условия</div>
            </div>
        </div>

        <div class="installment-alert flex">
            <i class="installment-alert__icon"></i>
            <p>Обязательным условием предоставления рассрочки <br> является своевременная оплата текущего потребления.</p>
        </div>

        <p v-if="lastPaymentLoading" class="page-hint">Загрузка...</p>
        <p v-else-if="!installmentAvailable" class="empty-text">Рассрочка недоступна для выбранного счёта. Обратитесь в абонентский отдел</p>

        <div v-if="installmentAvailable && dataUser" class="user-data-wrap installment-contacts">
            <div class="title">Контакты для связи</div>

            <ul class="user-data flex">
                <li class="user-data__type">Мобильный телефон</li>
                <li>
                    <input
                        type="text"
                        readonly
                        :value="dataUser.phone"
                        v-imask="phone"
                    >
                </li>
                <li class="user-data__edit">
                    <a href="#" @click.prevent="showModalEditPhone" class="table-edit"></a>
                </li>
            </ul>
            <ul class="user-data flex">
                <li class="user-data__type">E-mail</li>
                <li>{{dataUser.email ? dataUser.email : 'Нет'}}</li>
                <li class="user-data__edit">
                    <a href="#" @click.prevent="showModalEditEmail" class="table-edit"></a>
                </li>
            </ul>
            <ul class="user-data flex">
                <li class="user-data__type">ФИО</li>
                <li>{{fullName}}</li>
                <li class="user-data__edit">
                    <a href="#" @click.prevent="showModalEditPersonalData" class="table-edit"></a>
                </li>
            </ul>
            <div class="installment-term-wrap" :class="{active: isTermListOpen}">
                <ul class="user-data flex installment-term__head">
                    <li class="user-data__type">Срок рассрочки</li>
                    <li>{{selectedInstallmentTerm}}</li>
                    <li class="user-data__edit" @click.prevent="toggleTermList">
                        <span class="installment-term__arrow"></span>
                    </li>
                </ul>
                <transition name="slidedown">
                    <div v-if="isTermListOpen" class="installment-term__list">
                        <div
                            v-for="term in installmentTerms"
                            :key="term"
                            class="installment-term__option"
                            :class="{selected: selectedInstallmentTerm === term}"
                            @click.prevent="selectTerm(term)"
                        >{{term}}</div>
                    </div>
                </transition>
            </div>
        </div>

        <a
            v-if="installmentAvailable && !sendSuccess"
            href="#"
            class="button"
            :disabled="sending"
            @click.prevent="sendInstallment"
        >{{sending ? 'Отправка...' : 'Отправить заявку'}}</a>
        <p v-if="sendError" class="input-error">{{sendError}}</p>
        <p v-if="sendSuccess" class="installment-success">Заявка на рассрочку отправлена. С вами свяжется сотрудник Центра обслуживания.</p>
    </div>
</template>

<script>
import axios from "axios"
import { IMaskDirective } from 'vue-imask'
import { passesInstallmentDebtCheck } from '@/store'

export default {
    name: 'user-installment',
    data() {
        return {
            phone: {
                mask: '+{7} (000) 000-00-00'
            },
            modalType: '',
            isTermListOpen: false,
            selectedInstallmentTerm: 'до 12 месяцев',
            installmentTerms: ['до 6 месяцев', 'до 12 месяцев', 'индивидуально'],
            sending: false,
            sendSuccess: false,
            sendError: ''
        }
    },
    directives: {
        imask: IMaskDirective
    },
    mounted() {
        this.$store.commit('getUserInfo')
        this.ensureLastPaymentLoaded()
    },
    computed: {
        activeAccount() {
            return this.$store.state.currentAccount || (this.$store.state.accounts.length ? this.$store.state.accounts[0] : false)
        },
        passesDebtCheck() {
            return passesInstallmentDebtCheck(this.$store.state.installmentDebtLimit, this.activeAccount)
        },
        lastPaymentLoading() {
            if (!this.activeAccount)
                return true

            if (!this.passesDebtCheck)
                return false

            let cache = this.$store.state.lastPayments[this.activeAccount.account_id]

            return cache === undefined || (cache && cache.pending)
        },
        installmentAvailable() {
            return this.$store.getters.canInstallment(this.activeAccount)
        },
        dataUser() {
            return this.$store.state.dataUser
        },
        fullName() {
            if (!this.dataUser || !this.dataUser.name || this.dataUser.name === 'Без имени')
                return 'Не указано'

            return [
                this.dataUser.surname,
                this.dataUser.name,
                this.dataUser.second_name
            ].filter(Boolean).join(' ').trim() || 'Не указано'
        }
    },
    watch: {
        activeAccount() {
            this.ensureLastPaymentLoaded()
        }
    },
    methods: {
        async sendInstallment() {
            if (this.sending) return

            if (!this.dataUser || !this.dataUser.phone || !this.dataUser.phone.trim()) {
                this.sendError = 'Введите номер телефона'
                return
            }

            if (!this.dataUser.email) {
                this.sendError = 'Укажите E-mail'
                return
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.dataUser.email)) {
                this.sendError = 'Некорректный E-mail'
                return
            }

            let formData = new FormData()

            formData.append('account_id', this.activeAccount.account_id)
            formData.append('phone', this.dataUser.phone)
            formData.append('email', this.dataUser.email)
            formData.append('category', 'Оплата')
            formData.append('theme', 'рассрочка')
            formData.append('text', `Заявление на рассрочку платежа по лицевому счету №${this.activeAccount.client_number}. Срок рассрочки: ${this.selectedInstallmentTerm}.`)

            this.sending = true

            try {
                await axios.post(
                    this.$store.state.apiUrl + '/api/questions',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                this.sendSuccess = true
                this.sendError = ''
                this.$store.commit('getFeedback')
            } catch(e) {
                console.log(e.response ? { status: e.response.status, data: e.response.data } : e.message)
                if (e.response && e.response.data) {
                    if (e.response.data.errors) {
                        if (e.response.data.errors.text)
                            this.sendError = e.response.data.errors.text[0]
                        else if (e.response.data.errors.phone)
                            this.sendError = e.response.data.errors.phone[0]
                        else if (e.response.data.errors.email)
                            this.sendError = e.response.data.errors.email[0]
                        else if (e.response.data.errors.category)
                            this.sendError = e.response.data.errors.category[0]
                        else if (e.response.data.errors.theme)
                            this.sendError = e.response.data.errors.theme[0]
                        else
                            this.sendError = 'Не удалось отправить заявку. Попробуйте ещё раз.'
                    } else
                        this.sendError = 'Не удалось отправить заявку. Попробуйте ещё раз.'
                } else
                    this.sendError = 'Не удалось отправить заявку. Попробуйте ещё раз.'
            } finally {
                this.sending = false
            }
        },
        ensureLastPaymentLoaded() {
            let account = this.activeAccount

            if (!account || !this.passesDebtCheck)
                return

            if (this.$store.state.lastPayments[account.account_id] === undefined)
                this.$store.commit('getLastPayment', account.account_id)
        },
        showModalEditPhone() {
            this.modalType = 'editPhone'
            this.$refs.modal.showModal()
        },
        showModalEditEmail() {
            this.modalType = 'editEmail'
            this.$refs.modal.showModal()
        },
        showModalEditPersonalData() {
            this.modalType = 'editPersonalData'
            this.$refs.modal.showModal()
        },
        toggleTermList() {
            this.isTermListOpen = !this.isTermListOpen
        },
        selectTerm(term) {
            this.selectedInstallmentTerm = term
            this.isTermListOpen = false
        }
    }
}
</script>

<style scoped>
.installment-success {
    font-size: 14px;
    line-height: normal;
    padding: 8px 0 0;
    margin: 0;
    color: #11B548;
}

.slidedown-enter-active {
    transition: max-height 0.5s ease;
}

.slidedown-leave-active {
    transition: max-height 0.1s ease;
}

.slidedown-enter-to,
.slidedown-leave-from {
    overflow: hidden;
    max-height: 200px;
}

.slidedown-enter-from,
.slidedown-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>
